import React, { useEffect, useRef } from "react";

const ProtectedImage = ({ src, width = "226", height = "213", alt = "" }) => {

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    const dpr = window.devicePixelRatio || 1;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    ctx.scale(dpr, dpr);
    img.onload = () => {
      ctx.drawImage(img, 0, 0, width, height);
    };
    img.src = src;
  }, [src, width, height]);

  return (
    <div
      style={{
        position: "relative",
        width,
        height,
        userSelect: "none",
        WebkitUserDrag: "none",
        cursor: 'pointer'
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ display: "block" }}
      />
      {/* Transparent overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width,
          height,
          zIndex: 10,
          background: "rgba(255,255,255,0)",
        }}
      ></div>
    </div>
  );
};

export default ProtectedImage;
